import { render, staticRenderFns } from "./MyRequestView.vue?vue&type=template&id=0cbc54d6&scoped=true"
import script from "./MyRequestView.vue?vue&type=script&lang=js"
export * from "./MyRequestView.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/abiturient/MyRequestView.css?vue&type=style&index=0&id=0cbc54d6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc54d6",
  null
  
)

export default component.exports